import React from "react";
import banner9 from "../assets/banner9.jpg"; // reuse banner4 or replace with relevant image

export default function PolicyFinancialAnalysis() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Policy & Financial Analysis</h2>
        <p className="text-muted small">
          Providing insights on policy frameworks and financial systems for better decision-making.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner9} 
          alt="Policy & Financial Analysis" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group offers comprehensive policy and financial analysis to support 
          organisational planning, budgeting, and decision-making. Our team evaluates 
          policy frameworks, financial systems, and institutional processes to identify 
          opportunities for optimisation and compliance. We provide actionable recommendations 
          grounded in evidence, sector knowledge, and practical experience to improve outcomes 
          and organisational effectiveness.
        </p>
      </div>

    </section>
  );
}
